import { render, staticRenderFns } from "./DimensionBulkButton.vue?vue&type=template&id=67bb427e&scoped=true"
import script from "./DimensionBulkButton.vue?vue&type=script&lang=js"
export * from "./DimensionBulkButton.vue?vue&type=script&lang=js"
import style0 from "./DimensionBulkButton.vue?vue&type=style&index=0&id=67bb427e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb427e",
  null
  
)

export default component.exports